import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'
import { Plus } from 'lucide-react'
import { ROUTES } from '../../routes'

export interface CreateSessionButtonProps {
  /** Button text - defaults to "Create Session" */
  text?: string
  /** Additional CSS classes */
  className?: string
  /** Button variant - defaults to "primary" */
  variant?: 'primary' | 'secondary'
  /** Icon size - defaults to 24 */
  iconSize?: number
  /** Whether to show the plus icon - defaults to true */
  showIcon?: boolean
}

const CreateSessionButton: React.FC<CreateSessionButtonProps> = ({
  text,
  className = '',
  variant = 'primary',
  iconSize = 24,
  showIcon = true
}) => {
  const { t } = useTranslation()
  const resolvedText = text ?? t('sessions.createSession')
  const navigate = useNavigate()
  const location = useLocation()

  const handleCreateSession = () => {
    navigate(ROUTES.CREATE_SESSION, {
      state: { from: location.pathname }
    })
  }

  const buttonClass = `btn btn-${variant} ${className}`.trim()

  return (
    <button 
      className={buttonClass}
      onClick={handleCreateSession}
    >
      {showIcon && <Plus size={iconSize} strokeWidth={2.5} />}
      <span>{resolvedText}</span>
    </button>
  )
}

export default CreateSessionButton
